import growthSocialLogo from "@/assets/growth-social-logo.png";
import growthSocialLogoDark from "@/assets/growth-social-logo-dark.png";

interface GrowthSocialLogoProps {
  variant?: 'light' | 'dark' | 'auto';
  height?: number;
  className?: string;
  animate?: boolean;
}

export const GrowthSocialLogo = ({ 
  variant = 'light', 
  height = 32, 
  className = '', 
  animate = false 
}: GrowthSocialLogoProps) => {
  const logoSrc = variant === 'dark' ? growthSocialLogoDark : growthSocialLogo;
  
  return (
    <img
      src={logoSrc}
      alt="Growth Social - The Social Media Platform for B2B SaaS"
      style={{ height: `${height}px`, width: 'auto' }}
      className={`
        object-contain object-left
        ${animate ? 'transition-transform duration-200 hover:scale-105' : ''}
        ${className}
      `.trim()}
    />
  );
};
